<template>
  <div>
      <div class="box">
           <headTail   current='参赛'></headTail>
               <!-- 图片开始 -->
        <div class="imge-box"> 
           <img class="imge-box-img" src="../image/huod.gif">
        </div>
        <!-- 扫描 -->
        <div class="shao"> 
            <div class="shao-boxxx">
                 <img class="shao-img" src="../image/erweima2.png">
                 <div class="shao-wen" style="font-size: 35px;">扫码进入报名页面</div>  
            </div>
           
        </div>
          <headBar></headBar>
      </div>
  </div>

</template>
<script>
import * as config from "@/util/berurl.js";
import qs from 'qs'
export default {
   
  name: 'activity',
  data () {
    return {
      banquanType:3,
     api:config.basePath,
    }
  },
  methods:{
  getpoint(){	
				var local = window.location.href; // 获取页面url
				this.$axios({
					url: this.api+'api-cms/notAuth/activity/point',
					method: 'post',
		      headers: { 'content-type': 'application/x-www-form-urlencoded' },
			  data: qs.stringify({reqPageUrl: local}),
						
				}).then((res) =>{ 

        })
    },
  },
  mounted() {
    this.getpoint()
  }
}
</script>
<style scoped>
.shao-boxxx{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.shao-wen{
  color: #3E514F;
  font-size: 60px;
  margin: auto;
  /* width: 497px; */
   font-weight: 400;
color: #333333;
}
/* .shao-wen2{
  color: #333333;
  font-size: 60px;
  margin: auto;
  width: 245px;
  margin-top: 399px;
} */
.shao-img{
  width: 475px;
  height: 475px;
  margin: auto;
  margin-bottom: 158px;
}
.shao{
  background: url(../image/huod2.png) no-repeat ;
  background-size:100% 100%;
  padding-top: 324px;
  padding-left: 723px;
  padding-right: 722px;
  padding-bottom: 395px;
  background-size: cover;
}
.box{
  width: 1920px;
 
}
.imge-box{
  height: 368px;
   width: 1920px;
}
.imge-box-img{
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/participating.vue